// src/components/Admin/PieCountryCard.tsx
import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Sector,
} from 'recharts';
import { CountryCount } from '../../types/interfaces';

interface Props {
  title: string;
  total: number;
  data: CountryCount[];
}

const COLORS = [
  '#2563EB', '#7C3AED', '#10B981', '#EA580C', '#E11D48',
  '#0EA5E9', '#F59E0B', '#4F46E5', '#EF4444', '#14B8A6',
];

const PieCountryCard: React.FC<Props> = ({ title, total, data }) => (
  <div className="flex-1 bg-slate-50/70 backdrop-blur-sm border-2 border-slate-300 ring-1 ring-slate-200 p-6 rounded-xl shadow-xl flex flex-col lg:flex-row gap-6">
    {/* bloque IZQ ─ total + gráfico */}
    <div className="flex-1 flex flex-col items-center">
      <h2 className="font-semibold text-base text-slate-700 mb-1">{title}</h2>

      <p className="text-4xl font-extrabold text-slate-800 mb-4">
        {total.toLocaleString()}
      </p>

      <ResponsiveContainer width="100%" height={220}>
        <PieChart>
          <Pie
            data={data}
            dataKey="count"
            nameKey="country"
            innerRadius={50}
            outerRadius={85}
            paddingAngle={1}
            label={false}
            activeShape={(props: any) => <Sector {...props} stroke="#fff" />}
          >
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            cursor={{ fill: 'transparent' }}
            formatter={(v: number) => v.toLocaleString()}
            contentStyle={{ fontSize: '0.75rem', borderRadius: '0.5rem' }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>

    {/* bloque DCHA ─ tabla */}
    <div className="flex-1">
      <h3 className="font-medium text-slate-700 mb-3">Top 10 países</h3>
      <ul className="space-y-1 text-sm text-slate-600">
        {data.map((c, idx) => (
          <li key={c.country} className="flex justify-between">
            <div className="flex items-center gap-2">
              <span
                className="block h-3 w-3 rounded-full"
                style={{ background: COLORS[idx % COLORS.length] }}
              />
              <span>{c.country}</span>
            </div>
            <span className="font-semibold">
              {c.count.toLocaleString()}
            </span>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default PieCountryCard;